// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//
import { VendorType } from '@shared/constants/vendor';
import { VendorUser } from './user';

interface Address {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}

interface BusinessContact {
  name: string;
  title: string;
  email: string;
  phone: string;
}

export interface ProjectManager {
  id: number;
  name: string;
  title: string;
  email: string;
  phone: string;
  blocked: boolean;
}

export interface VendorUsersDTO {
  vendorName: string;
  vendorUsers: Array<VendorUser>;
}

export interface VendorDTO {
  id: number;
  name: string;
  accountingCode: string;
  types: Array<VendorType>;
  address: Address;
  businessContact: BusinessContact;
  projectManagers: ProjectManager; // This used to be an array.
}

export class Vendor {
  id: number;
  name: string;
  accountingCode: string;
  types: Array<VendorType>;
  address: Address;
  businessContact: BusinessContact;
  projectManagers: ProjectManager; // This used to be an array.

  constructor(dto: VendorDTO) {
    this.update(dto);
  }

  get asJson(): VendorDTO {
    return {
      id: this.id,
      name: this.name,
      accountingCode: this.accountingCode,
      types: this.types,
      address: this.address,
      businessContact: this.businessContact,
      projectManagers: this.projectManagers
    };
  }

  update(newData: Partial<VendorDTO>): VendorDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}